import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import  { TdView } from "./td-view"


export class TdComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Table Cell';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = false;
        
        // this.addProperty("Content","",new ContentPropertyType(this),null,true);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new TdElement(parent);

        return result;
    }
}

export class TdElement extends ChildAcceptableFormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new TdView();
    }
    public getTypeId(): string {
        return "VM-FE15C424-522B-4C09-827A-A99C4FDEC025"
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitTdElement(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content && this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
    
}
